import { Space } from 'antd';
import React from 'react';

type ISelectionActionsProps = {
  customActions?: React.ReactNode;
};

export default function SelectionActions({
  customActions,
}: ISelectionActionsProps) {
  return customActions ?? <Space></Space>;
}
